import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

//* Models
import { IClubAlsuper } from '@models/client.model';
import { TGetAwardsResponse } from '@models/awards.model';
import { TGetZonesResponse } from '@models/zones.model';
import { TGetClubAlsuperPointsResponse, TSetClubAlsuperBody } from '@models/club.model';

@Injectable({
  providedIn: 'root'
})
export class ClubService {

  private URL = environment.rootUrl;
  private URL_SERVICES = environment.rootServicesUrl;

  public reloadClubAlsuper$ = new EventEmitter<boolean>();

  constructor(
    private http: HttpClient
  ) { }

  public getClubPoints(): Promise<any> {
    return this.http.get(`${this.URL_SERVICES}/club-alsuper`).toPromise();
  }

  public getClubPointsByNumber(club_id: string, number?: string): Promise<TGetClubAlsuperPointsResponse> {
    return firstValueFrom(this.http.get<TGetClubAlsuperPointsResponse>(`${this.URL}/club-alsuper?membership=${club_id}&number=${number ?? ''}`));
  }

  public setClubAlsuperCard(body: TSetClubAlsuperBody): Promise<object> {
    return firstValueFrom(this.http.patch(`${this.URL}/club-alsuper/setClubAlsuper`, body));
  }

  public deleteClubAlsuperCard(membership: string): Promise<object> {
    return firstValueFrom(this.http.delete(`${this.URL}/club-alsuper/quit?membership=${membership}`));
  }

  public async getZones(): Promise<TGetZonesResponse> {
    return firstValueFrom(this.http.get<TGetZonesResponse>(`${this.URL}/rewards/zones`));
  }

  public async getRewards(zone: string, page: number, limit: number): Promise<TGetAwardsResponse> {
    return firstValueFrom(this.http.get<TGetAwardsResponse>(`${this.URL}/rewards?zona=${zone}&page=${page}&limit=${limit}`));
  }

  public async getRewardsById(id: number): Promise<any> {
    return this.http.get(`${this.URL}/rewards/${id}`).toPromise();
  }

  public async getAlsuperCardPointsByNumberWS(card_number: string): Promise<any> {
    return this.http.get(`${this.URL}/alsuper-card?card_number=${card_number}`).toPromise();
  }

  public async getValidateClient(membership: any, cellphone: any): Promise<any> {
    try {
      return await this.http.get(`${this.URL}/ws-club-alsuper?membership=${membership}&cellphone=${cellphone}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public async updateClubAlsuperCard(data: IClubAlsuper): Promise<any> {
    try {
      return await this.http.post(`${this.URL}/ws-club-alsuper`, data).toPromise();
    } catch (error: any) {
      return error;
    }
  }

  public async getSettlements(zip_code: string): Promise<any> {
    try {
      return await this.http.get(`${this.URL}/ws-club-alsuper/settlements/${zip_code}`).toPromise();
    } catch (error: any) {
      return error;
    }
  }
}
